import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class DockAppointments_ds_get_dock_appointments_by_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { appointment_ids: number[] }): 
  Promise<{ result: { Id?: number, AssignedBy?: string, AssignedOn?: string, CancelledBy?: string, CancelledOn?: string, CheckedInBy?: string, CheckedInOn?: string, CompletedBy?: string, CompletedOn?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DriverLicense?: string, DriverName?: string, InProcesesBy?: string, InProcessOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledBy?: string, ScheduledDeparture?: string, ScheduledOn?: string, StatusId?: number, TypeId?: number, VehicleLicense?: string, WarehouseId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledProject?: { LookupCode?: string }, ScheduledCarrier?: { Name?: string }, CancelReasonCode?: { Name?: string }, Warehouse?: { Id?: number, Name?: string, TimeZoneId?: string }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedScheduledDeparture?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string }, convertedAssignedOn?: { id?: number, convertedDate?: string }, convertedInProcessOn?: { id?: number, convertedDate?: string }, convertedCompletedOn?: { id?: number, convertedDate?: string }, convertedCancelledOn?: { id?: number, convertedDate?: string }, convertedScheduledOn?: { id?: number, convertedDate?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.appointment_ids)) {
      missingRequiredInParams.push('\'appointment_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointments_by_ids/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { appointment_ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AssignedBy?: string, AssignedOn?: string, CancelledBy?: string, CancelledOn?: string, CheckedInBy?: string, CheckedInOn?: string, CompletedBy?: string, CompletedOn?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DriverLicense?: string, DriverName?: string, InProcesesBy?: string, InProcessOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledBy?: string, ScheduledDeparture?: string, ScheduledOn?: string, StatusId?: number, TypeId?: number, VehicleLicense?: string, WarehouseId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledProject?: { LookupCode?: string }, ScheduledCarrier?: { Name?: string }, CancelReasonCode?: { Name?: string }, Warehouse?: { Id?: number, Name?: string, TimeZoneId?: string }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedScheduledDeparture?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string }, convertedAssignedOn?: { id?: number, convertedDate?: string }, convertedInProcessOn?: { id?: number, convertedDate?: string }, convertedCompletedOn?: { id?: number, convertedDate?: string }, convertedCancelledOn?: { id?: number, convertedDate?: string }, convertedScheduledOn?: { id?: number, convertedDate?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.appointment_ids)) {
      missingRequiredInParams.push('\'appointment_ids\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointments_by_ids/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { appointment_ids: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, AssignedBy?: string, AssignedOn?: string, CancelledBy?: string, CancelledOn?: string, CheckedInBy?: string, CheckedInOn?: string, CompletedBy?: string, CompletedOn?: string, CreatedSysDateTime?: string, CreatedSysUser?: string, DriverLicense?: string, DriverName?: string, InProcesesBy?: string, InProcessOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledBy?: string, ScheduledDeparture?: string, ScheduledOn?: string, StatusId?: number, TypeId?: number, VehicleLicense?: string, WarehouseId?: number, AssignedLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledLocation?: { Id?: number, Name?: string, ShortName?: string, WarehouseId?: number }, ScheduledProject?: { LookupCode?: string }, ScheduledCarrier?: { Name?: string }, CancelReasonCode?: { Name?: string }, Warehouse?: { Id?: number, Name?: string, TimeZoneId?: string }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedScheduledDeparture?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string }, convertedAssignedOn?: { id?: number, convertedDate?: string }, convertedInProcessOn?: { id?: number, convertedDate?: string }, convertedCompletedOn?: { id?: number, convertedDate?: string }, convertedCancelledOn?: { id?: number, convertedDate?: string }, convertedScheduledOn?: { id?: number, convertedDate?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.appointment_ids)) {
      missingRequiredInParams.push('\'appointment_ids\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/DockAppointments/datasources/ds_get_dock_appointments_by_ids/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      appointment_ids: number[]    }) {
        if(isNil(inParams.appointment_ids)) {
          return true; 
        }
      return false;
    }
}
